<script setup lang="ts">
import { onMounted, reactive, defineProps, defineEmits } from "vue";
import * as api from "@/api";
import { useRouter } from "vue-router";
const router = useRouter();
const props = defineProps({
  logo: [],
});
const emits = defineEmits(["toTop"]);
const pageSrc = reactive({
  log: "页面创建了",
  fastLink: [] as any,
  connect: [] as any,
  filing: [] as any,
  qrCode: [] as any,
});
onMounted(async () => {
  fastLink();
  connect();
  filing();
  getQrCode();
});
const setTitle = (item: any) => {
  document.title = item + "标题";
};
/**
 * 获取快速链接
 */
const fastLink = async () => {
  try {
    const res = await api.getPageMessage(143);
    pageSrc.fastLink = res?.data.content_list;
  } catch (e) {
    console.error(e);
  }
};
/**
 * 获取公司二维码
 */
const getQrCode = async () => {
  try {
    const res = await api.getAdImgAndVideo(50);
    pageSrc.qrCode = res?.data.ad_list[0].pic;
  } catch (e) {
    console.error(e);
  }
};
/**
 * 获取备案号
 */
const filing = async () => {
  try {
    const res = await api.getPageMessage(145);
    pageSrc.filing = res?.data.content_list;
  } catch (e) {
    console.error(e);
  }
};
/**
 * 获取联系方式
 */
const connect = async () => {
  try {
    const res = await api.getPageMessage(263);
    pageSrc.connect = res?.data.content_list;
  } catch (e) {
    console.error(e);
  }
};
const toTemplate = (item: any, index: number) => {
  if (item.jump_link == "/") return;
  const items = item.jump_link.split("_");
  items[0] = items[0].split("/")[1];
  router.push({
    name: items[0],
    query: {
      componentId: items[2],
      name: item.title,
      waitsources: items[1],
      adId: items[3],
    },
  });
  toTop();
};
const toTop = () => {
  emits("toTop", "");
};
</script>
<template>
  <div class="footPage XhorizontalCenter">
    <div class="foot pageWidth">
      <!-- 优化为响应式布局的容器 -->
      <div class="foot_content">
        <!-- 左侧Logo和二维码区域 - 修改为并排显示 -->
        <div class="foot_left">
          <div class="foot_images_container">
            <div class="foot_logo">
              <img :src="props.logo" alt="公司logo" />
            </div>
            <div class="foot_qrCodeContainer">
              <img class="foot_qrCode" :src="pageSrc.qrCode" alt="公司二维码" />
              <div class="qrCode_tooltip">扫码关注我们</div>
            </div>
          </div>
        </div>

        <!-- 右侧菜单和版权信息区域 -->
        <div class="foot_right">
          <div class="foot_menuBar">
            <div class="foot_menuBar_link">
              <div class="title">快速链接</div>
              <div class="bar">
                <div
                  v-for="(item, index) in pageSrc.fastLink"
                  @click="toTemplate(item, index)"
                  :key="index"
                  class="menu_item"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
            <div class="foot_menuBar_aboutUs">
              <div class="title">联系我们</div>
              <div class="bar">
                <div
                  v-for="(item, index) in pageSrc.connect"
                  :key="index"
                  class="menu_item"
                >
                  {{ item.title }}
                </div>
              </div>
            </div>
          </div>

          <!-- 版权信息 -->
          <div class="foot_copyright">
            <div v-for="(item, index) in pageSrc.filing" :key="index">
              <a :href="item.jump_link" target="_blank">{{ item.title }}</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
.footPage {
  width: 100%;
  background-color: #000;
  padding: 40px 0;
}

.foot {
  color: #ffffff;
  font-size: 13px;
  position: relative;
  height: auto;
  overflow: visible;
}

.foot_content {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
  gap: 40px;
}

.foot_left {
  display: flex;
  align-items: center;
  justify-content: center;
}

/* 添加新的容器使两张图片并排显示 */
.foot_images_container {
  display: flex;
  align-items: center;
  gap: 20px;
}

.foot_logo {
  width: 120px;
  height: 120px;
  transition: all 0.3s ease;
  cursor: pointer;
  margin: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: contain;
  }
}

.foot_qrCodeContainer {
  position: relative;
  width: 100px;
  height: 100px;
  transition: all 0.3s ease;
  margin: 0;
}

.foot_qrCode {
  width: 100%;
  height: 100%;
  object-fit: contain;
  transition: all 0.3s ease;
}

.foot_qrCodeContainer:hover .foot_qrCode {
  transform: scale(1.2);
  z-index: 999;
}

.qrCode_tooltip {
  position: absolute;
  bottom: -30px;
  left: 50%;
  transform: translateX(-50%);
  background-color: rgba(0, 0, 0, 0.8);
  color: white;
  padding: 5px 10px;
  border-radius: 4px;
  font-size: 12px;
  white-space: nowrap;
  opacity: 0;
  transition: opacity 0.3s ease;
  pointer-events: none;
}

.foot_qrCodeContainer:hover .qrCode_tooltip {
  opacity: 1;
}

.foot_right {
  flex: 1;
  min-width: 400px;
}

.foot_menuBar {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 40px;
  margin-bottom: 30px;
}

.foot_menuBar_link,
.foot_menuBar_aboutUs {
  flex: 1;
  min-width: 200px;
  padding-top: 20px;
}

.foot_menuBar_aboutUs {
  margin-left: 0;
}

.title {
  font-size: 16px;
  font-weight: 600;
  color: #fff;
  margin-bottom: 20px;
  position: relative;
  padding-bottom: 10px;

  &::after {
    content: "";
    position: absolute;
    left: 0;
    bottom: 0;
    width: 40px;
    height: 2px;
    background-color: #3498db;
  }
}

.bar {
  display: flex;
  flex-wrap: wrap;
  gap: 15px 30px;
}

.menu_item {
  min-width: auto;
  margin: 0;
  cursor: pointer;
  user-select: none;
  color: #ccc;
  transition: color 0.3s ease;

  &:hover {
    color: #3498db;
  }
}

.foot_copyright {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 15px 30px;
  padding-top: 20px;
  border-top: 1px solid rgba(255, 255, 255, 0.1);

  a {
    color: #999;
    text-decoration: none;
    transition: color 0.3s ease;

    &:hover {
      color: #3498db;
    }
  }
}

// 响应式设计 - 平板设备
@media (max-width: 992px) {
  .foot_content {
    flex-direction: column;
    align-items: center;
  }

  .foot_left {
    order: 2;
  }

  .foot_right {
    order: 1;
    text-align: center;
  }

  .foot_menuBar {
    justify-content: center;
  }

  .title::after {
    left: 50%;
    transform: translateX(-50%);
  }
}

// 响应式设计 - 移动设备 (只展示联系我们和备案信息，改变编排模式)
@media (max-width: 768px) {
  .footPage {
    padding: 20px 0;
  }

  // 隐藏快速链接和图片
  .foot_left,
  .foot_menuBar_link {
    display: none !important;
  }

  // 重新编排联系我们和备案信息
  .foot_content {
    padding: 0 20px;
  }

  .foot_right {
    min-width: 100%;
    display: flex;
    flex-direction: column;
  }

  .foot_menuBar {
    margin-bottom: 0;
    padding-bottom: 20px;
    border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  }

  .foot_menuBar_aboutUs {
    width: 100%;
    padding-top: 10px;
    text-align: center;
  }

  .foot_menuBar_aboutUs .title {
    font-size: 18px;
    margin-bottom: 15px;
  }

  .foot_menuBar_aboutUs .bar {
    justify-content: center;
    flex-direction: column;
    gap: 12px;
    align-items: center;
  }

  .foot_menuBar_aboutUs .menu_item {
    font-size: 14px;
    padding: 5px 10px;
    border-radius: 4px;
    background-color: rgba(255, 255, 255, 0.05);
    width: fit-content;
  }

  .foot_copyright {
    flex-direction: column;
    gap: 12px;
    padding-top: 20px;
    border-top: none;
    text-align: center;
  }

  .foot_copyright a {
    display: block;
    font-size: 12px;
    padding: 5px 0;
  }
}
</style>
